var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmpresasMain mb24"},[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view',{on:{"msg":function($event){return _vm.$emit('msg',$event)},"httpError":function($event){return _vm.$emit('httpError',$event)}}})],1),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }